/**
 * Purchase Flow API
 * Re-exports all API functions and types
 */

// Core utilities
export { buildApiUrl, ApiError } from './core';
export type { ApiRequestOptions, ApiErrorResponse } from './core';

// Payment Sources API
export {
  fetchCombinedPaymentSources,
  fetchPaymentSources,
  addPaymentSource,
  setPaymentSourceAsDefault,
  getPaymentSourceConfig,
  updatePaymentSource,
  removePaymentSource
} from './paymentSources';

export type {
  ApiPaymentSource,
  ApiPaymentOption,
  CombinedPaymentSourcesResponse,
  FetchPaymentSourcesResponse,
  AddPaymentSourceResponse,
  PaymentSourceConfigResponse,
  SetDefaultResponse
} from './paymentSources';

// Purchase API
export {
  getProcessingData,
  createPurchase,
  getPurchaseStatus,
  getAdditionalPurchaseInfo
} from './purchase';

export type {
  ProcessingDataParams,
  ProcessingDataResponse,
  CreatePurchaseParams,
  CreatePurchaseResponse,
  PurchaseStatusResponse,
  PurchaseStatus,
  AdditionalPurchaseInfo
} from './purchase';

// Google Pay API
export {
  createPaymentSession,
  processPaymentSessionPayment
} from './googlePay';

export type { PaymentSessionResponse } from './googlePay';

// Apple Pay API
export {
  validateApplePayMerchant,
  updateApplePayToken
} from './applePay';

// Validation API (PAYG)
export {
  createPaymentValidation,
  getPaymentValidation
} from './validation';

export type {
  PaymentValidationState,
  PaymentValidationResponse,
  CreateValidationParams
} from './validation';
